import {LoadingOutlined} from "@ant-design/icons";
import React from "react";

const customerLoadingIcon =  <LoadingOutlined style={{ fontSize: 24 }} spin />

export default customerLoadingIcon;